/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frames_To_Insert_HelpInputs */



/**
* | output |
* | --- |
* | "Number of frames to insert between captions" |
*
* @param {Frames_To_Insert_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const frames_to_insert_help = /** @type {((inputs?: Frames_To_Insert_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frames_To_Insert_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre d’images à insérer entre les sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der zwischen den Untertiteln einzufügenden Frames")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di fotogrammi da inserire tra le didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество кадров для вставки между подписями")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de fotogramas a insertar entre subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕之间要插入的帧数")
	if (locale === "ja") return /** @type {LocalizedString} */ ("キャプション間に挿入するフレームの数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन के बीच में डालने के लिए फ़्रेमों की संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número de quadros a inserir entre as legendas")
	return /** @type {LocalizedString} */ ("Number of frames to insert between captions")
});